import Candidate from '../../store/types/models/Candidate'
import DetailsTile from '../../components/Tile/DetailsTile'
import { t } from 'i18next'
import {
  AlternateEmail,
  Article,
  CalendarMonth,
  Description,
  Folder,
  Home,
  LocationCity,
  Person,
  Phone,
  Work,
} from '@mui/icons-material'
import React from 'react'
import { Typography } from '@mui/material'
import { formatStringDate } from '../../store/utils/dateUtils'

type CandidateDetailsDataProps = {
  candidateDetails: Candidate | undefined
}

const CandidateDetailsData = ({ candidateDetails }: CandidateDetailsDataProps) => {
  return (
    <>
      <DetailsTile
        title={t('page.candidateDetails.tiles.fullName')}
        description={candidateDetails ? `${candidateDetails.firstName} ${candidateDetails.lastName}` : '-'}
        icon={<Person />}
      />

      <DetailsTile
        title={t('page.candidateDetails.tiles.domicile')}
        description={candidateDetails?.domicile || '-'}
        icon={<Home />}
      />

      <Typography variant="h5" color="text.highEmphasis">
        {t('page.candidateDetails.contactInformation')}
      </Typography>

      <DetailsTile
        title={t('page.usersProfile.tiles.email')}
        description={candidateDetails?.email || '-'}
        icon={<AlternateEmail />}
      />

      <DetailsTile
        title={t('page.usersProfile.tiles.phone')}
        description={candidateDetails?.phoneNumber || '-'}
        icon={<Phone />}
      />

      <Typography variant="h5" color="text.highEmphasis">
        {t('page.candidateDetails.applicationInformation')}
      </Typography>

      <DetailsTile
        title={t('page.candidateDetails.tiles.cv')}
        description={
          <a style={{ color: 'inherit' }} href={candidateDetails?.cv || undefined} target="_blank" rel="noreferrer">
            {candidateDetails?.cv || '-'}
          </a>
        }
        icon={<Description />}
      />

      <DetailsTile
        title={t('page.candidateDetails.tiles.dateOfReceipt')}
        description={formatStringDate(candidateDetails?.dateOfApplication.toString()) || '-'}
        icon={<CalendarMonth />}
      />

      <DetailsTile
        title={t('page.candidateDetails.tiles.workingMethod')}
        description={t(`workingMethod.${candidateDetails?.workingMethod.toLowerCase()}`) || '-'}
        icon={<Work />}
      />

      <DetailsTile
        title={t('page.candidateDetails.tiles.localization')}
        description={candidateDetails?.localization.value || '-'}
        icon={<LocationCity />}
      />

      <DetailsTile
        title={t('page.candidateDetails.tiles.repository')}
        description={
          <a
            style={{ color: 'inherit' }}
            href={candidateDetails?.repository || undefined}
            target="_blank"
            rel="noreferrer"
          >
            {candidateDetails?.repository || '-'}
          </a>
        }
        icon={<Folder />}
      />

      <DetailsTile
        title={t('page.candidateDetails.tiles.description')}
        description={candidateDetails?.description || '-'}
        icon={<Article />}
        wrap
      />
    </>
  )
}

export default CandidateDetailsData
